<template>
  <el-dialog :visible.sync="visible" width="330px" :before-close="() => (visible = false)">
    <div slot="title">
      <span :style="{ fontWeight: 'bold' }">{{ title }}</span>
    </div>
    <div class="push-city-modal">
      <el-cascader
        v-model="city"
        :options="list"
        :show-all-levels="false"
        filterable
        :props="{ expandTrigger: 'hover', value: 'name', label: 'name' }"
        style="width:100%"
      ></el-cascader>
      <div>
        <template v-if="isReview">
          <el-checkbox :disabled="disabledDefault" class="push-city-check" v-model="setDefault"
            >将所选地区设定为默认地区
          </el-checkbox>
          <el-tooltip
            effect="dark"
            content="选定用户所在地区后，在案例推送等使用场景下，将默认按此地区推送案例或进行其他应用"
            placement="bottom-start"
          >
            <i class="iconfont icon-shuoming drag-tip"></i>
          </el-tooltip>
          <p class="push-city-tip">
            合同风险点的相关案例，小包公法律AI将<b>优先</b>为您推送您所选定的城市，若该城市无相关案例则自动为您补充全国其他城市案例。
          </p>
        </template>
      </div>
    </div>
    <span slot="footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button :disabled="!city" type="primary" @click="confirmHandle">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import provinceCityJson from '@/assets/area/province_city.json';
const national = {
  name: '全国',
  children: [
    {
      name: '全国'
    }
  ]
};

export default {
  components: {},
  data() {
    return {
      city: '',
      confirmLoading: false,
      list: [national, ...provinceCityJson],
      setDefault: false,
      disabledDefault: false
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '选择案例优先推送的区域'
    },
    curCity: {
      type: String,
      default: ''
    },
    isReview: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    visible: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit('update:show', val);
      }
    }
  },
  watch: {
    city(val) {
      this.disabledDefault = val.includes('全国') || false;
    }
  },
  mounted() {
    this.curCity &&
      this.list.forEach(item => {
        const city = item.children.find(j => {
          return j.name === this.curCity;
        });
        if (city) {
          this.city = [item.name, city.name];
        }
      });
  },
  methods: {
    confirmHandle() {
      this.visible = false;
      this.$emit('confirm', this.city, this.setDefault);
    }
  }
};
</script>

<style lang="scss" scoped>
.push-city-modal {
  .push-city-check {
    margin: 14px 0 10px;
    margin-right: 10px;
    ::v-deep {
      .el-checkbox__input {
        position: relative;
        top: -1px;
      }
    }
  }
  .push-city-tip {
    color: #9194a0;
    font-size: 12px;
    line-height: 18px;
  }
}
</style>
